<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1995"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1999"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2009"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2007" /></clipPath></defs><g
     id="g2001"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2003"><g
         id="g2005"
         clip-path="url(#clipPath2009)"><g
           id="g2011"
           transform="translate(271.5908,400.6094)"><path
             d="m 0,0 h 20.211 c 6.576,0 11.99,-5.386 11.99,-11.991 V -35.32 H 55.53 c 6.577,0 11.963,-5.386 11.963,-11.99 v -20.211 c 0,-6.577 -5.386,-11.962 -11.963,-11.962 H 32.201 v -23.33 c 0,-6.604 -5.414,-11.99 -11.99,-11.99 H 0 c -6.577,0 -11.991,5.386 -11.991,11.99 v 23.33 H -35.32 c -6.576,0 -11.962,5.385 -11.962,11.962 v 20.211 c 0,6.604 5.386,11.99 11.962,11.99 h 23.329 v 23.329 C -11.991,-5.386 -6.577,0 0,0 Z"
             style="stroke:#000000;stroke-width:15.024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2013" /></g><g
           id="g2015"
           transform="translate(356.063,61.1323)"><path
             d="m 0,0 v -14.967 m 0,119.14 V 89.206 M 36.227,72.964 c 0,8.419 -6.86,15.278 -15.279,15.278 h -41.896 c -8.419,0 -15.279,-6.859 -15.279,-15.278 v -13.55 c 0,-8.419 6.86,-15.278 15.279,-15.278 H 5.471 20.948 c 8.419,0 15.279,-6.889 15.279,-15.28 V 15.279 C 36.227,6.888 29.367,0 20.948,0 h -41.896 c -8.39,0 -15.279,6.888 -15.279,15.279"
             style="stroke:#000000;stroke-width:15.024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2017" /></g><g
           id="g2019"
           transform="translate(71.9746,157.7085)"><path
             d="m 0,0 v 315.95 c 0,16.979 13.862,30.841 30.841,30.841 h 254.948 c 16.98,0 30.841,-13.862 30.841,-30.841 V 295.398 M 51.393,-98.787 H 30.841 C 13.862,-98.787 0,-84.926 0,-67.946 v 33.959"
             style="stroke:#000000;stroke-width:15.024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2021" /></g><g
           id="g2023"
           transform="translate(440.0254,354.3198)"><path
             d="m 0,0 v -315.978 c 0,-16.951 -13.89,-30.841 -30.841,-30.841 h -254.976 c -16.952,0 -30.841,13.89 -30.841,30.841 V 11.707 l 87.08,87.08 H -30.841 C -13.89,98.787 0,84.897 0,67.946 V 33.959"
             style="stroke:#000000;stroke-width:15.024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2025" /></g><g
           id="g2027"
           transform="translate(210.4473,453.1069)"><path
             d="m 0,0 -87.08,-87.08 h 49.606 C -16.866,-87.08 0,-70.214 0,-49.578 Z"
             style="stroke:#000000;stroke-width:15.024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2029" /></g><g
           id="g2031"
           transform="translate(171.1025,224.8613)"><path
             d="M 0,0 H 221.187 M 0,-29.792 H 221.187 M 0,-59.556 H 119.282 M 0,-89.348 H 119.282 M 0,-119.14 H 119.282 M 0,-148.904 H 119.282 M 0,-178.696 H 119.282 M 0,29.764 h 221.187"
             style="stroke:#000000;stroke-width:15.024;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2033" /></g></g></g></g></svg>
</template>
